// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3145": "95ae85be","6369": "4b4e1c47","718": "5f1609e0",}[chunkId] + ".css"
}